<template>
    <div class="px-4 py-1 sm:px-6">
        <div class="flex items-center gap-1">
            <div class="min-w-32">
                <p class="text-sm font-medium text-midea-text truncate">
                {{ data.name }}
                </p>
                <p class="text-xs text-gray-600">
                Created {{ moment(data.createdAt).fromNow() }}
                </p>
            </div>
            <div class="flex-grow"/>
            
            <div class="flex flex-col gap-1 bg-blue-500 p-2 rounded-md">
                <div class="text-xs text-blue-300">VAULT</div>
                <div class="text-xl -my-2 font-bold text-white">{{ data.miCarePointsInVault }}</div>
            </div>
            
            <div class="flex flex-col gap-1 bg-green-500 p-2 rounded-md">
                <div class="text-xs text-green-300">CREDIT</div>
                <div class="text-xl -my-2 font-bold text-white">{{ data.availableMiCarePoints }}</div>
            </div>
            
            <div class="flex flex-col gap-1 bg-gray-500 p-2 rounded-md">
                <div class="text-xs text-gray-300">SPENT</div>
                <div class="text-xl -my-2 font-bold text-white">{{ data.spentMiCarePoints }}</div>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'data'
    ],
}
</script>